import { render, staticRenderFns } from "./ProtocoloExterno.vue?vue&type=template&id=ff668cf4&scoped=true"
import script from "./ProtocoloExterno.vue?vue&type=script&lang=js"
export * from "./ProtocoloExterno.vue?vue&type=script&lang=js"
import style0 from "./ProtocoloExterno.vue?vue&type=style&index=0&id=ff668cf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff668cf4",
  null
  
)

export default component.exports